export const debugTimeout = localStorage.getItem("debugTimeout") ? parseInt(localStorage.getItem("debugTimeout")) : null